import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"
import { z } from "zod"

import { CniUsersTable } from "@/features/cni-users/components/CniUsersTable"

const searchSchema = z.object({
  id: z.string().optional(),
  role: z.string().optional(),
})

export const Route = createFileRoute("/_authed/cni/users")({
  component: CniUsersPage,
  validateSearch: (raw) => searchSchema.parse(raw),
})

function CniUsersPage() {
  const { t } = useTranslation("cni-users")
  const { id, role } = Route.useSearch()
  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="border-b border-ok-border px-6 py-4">
        <h1 className="text-lg font-semibold tracking-tight">{t("title")}</h1>
        <p className="text-xs text-ok-foreground-muted">{t("subtitle")}</p>
      </div>
      <CniUsersTable initialSelectedId={id ?? null} initialRole={role ?? null} />
    </div>
  )
}
